export const CONTEXT_PROJECT_CHANGE = "context.project.change";
export const CONTEXT_SECTION_CHANGE = "context.section.change";
export const CONTEXT_NAMESPACE_CHANGE = "context.namespace.change";
export const VIEW_CHANGE = "view.change";
